import styled, { css } from 'styled-components';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const PlayerChipContainer = styled.div`
    overflow-x: scroll;
    overflow-y: hidden;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const PlayerChips = styled.div`
    display: flex;
`;

export const PlayerItemContainer = styled.div<{ $isTeamLeaderCarousel: boolean }>`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    min-width: fit-content;
    height: 64px;
    border: 1px solid ${({ theme }) => theme.Surface.border};
    border-radius: 8px;
    margin-right: 16px;
    padding: 8px;
    align-items: center;
    white-space: nowrap;

    ${({ $isTeamLeaderCarousel }) =>
        $isTeamLeaderCarousel &&
        css`
            ${BaseStyle.Mixins.gaps.large}
            padding-right: 12px;
        `}
`;

export const PlayerHeadshotContainer = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const PlayerInfoContainer = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
`;

export const InfoContainer = styled.div`
    ${BaseStyle.Mixins.gaps.extraSmall}
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: fit-content;
`;

export const PlayerInfoWrapper = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14b']}
    ${BaseStyle.Mixins.gaps.extraSmall}
    display: flex;
    align-items: center;
    white-space: nowrap;
`;

export const GoalSubtextContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12m']}
    //NB: Without this, and the overflow hidden, letters that go below the baseline (eg y, g) get cut off.
    line-height: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const GoalScoreAndTimeContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12m']}
    ${BaseStyle.Mixins.gaps.extraSmall}
    display: flex;
    white-space: nowrap;
`;

export const BoldedTeam = styled.div<{ $isScoringTeam: boolean }>`
    ${({ $isScoringTeam }) =>
        $isScoringTeam &&
        css`
            ${BaseStyle.Mixins.fontStyles.ui['12b']}
        `}
    }
`;

export const TeamLeaderName = styled.div<{ $isLastName: boolean }>`
    ${BaseStyle.Mixins.fontStyles.ui['12m']}
    display: flex;
    min-width: fit-content;
    white-space: nowrap;

    ${({ $isLastName }) =>
        $isLastName &&
        css`
            ${BaseStyle.Mixins.fontStyles.ui['14b']}
        `}
}
`;

export const TeamLeaderTeam = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12m']}
`;

export const TeamLeaderCountContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const TeamLeaderCount = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['28b']}
`;

export const TeamLeaderCountCategory = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12m']}
`;

export const ToggleContainer = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    align-items: center;
    align-content: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 28px;
`;

export const ChevronLeft = styled(ChevronLeftIcon)<{ $disabled: boolean }>`
    font-size: 24px;
    transition: 0.5s;
    cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};

    path {
        color: ${({ $disabled, theme }) => ($disabled ? theme.Text.disabled : theme.Utility.cta)};
    }
`;

export const ChevronRight = styled(ChevronRightIcon)<{ $disabled: boolean }>`
    font-size: 24px;
    transition: 0.5s;
    cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};

    path {
        color: ${({ $disabled, theme }) => ($disabled ? theme.Text.disabled : theme.Utility.cta)};
    }
`;

export const StatsToggle = styled.div<{ $selected: boolean }>`
    transition: 0.5s;
    width: ${({ $selected }) => ($selected ? '24px' : '16px')};
    background: ${({ $selected, theme }) => ($selected ? theme.Utility.cta : theme.Text.disabled)};
    height: 2px;
    cursor: pointer;
`;

export const Toggles = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    overflow: auto;
`;
